import { render } from "./GoPage.vue?vue&type=template&id=7b7121b6"
import script from "./GoPage.vue?vue&type=script&lang=js"
export * from "./GoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__